import { graphql, useStaticQuery } from "gatsby"
import type { CloudBluePlan } from "@gatsby-plugin-definitions/fragments/CloudBluePlan"
import type { Label } from "@gatsby-plugin-generic-page/fragments/label"
import type { EmbeddedAssetSquidexMetadata } from "~/fragments/image"
import type { SquidexMarkdownEmbeddedContent } from "~/types/squidex"

type Query = {
  GraphCmsSquidex: {
    findCheckoutConfigurationSingleton: {
      flatData: {
        hasStepsInHeader: boolean | null
        expandedTerms: { id: number }[]
        termsText: SquidexMarkdownEmbeddedContent
        tabsTermId?: number
        hasGroupedTerms?: boolean | null
        groupedTermsText?: string | SquidexMarkdownEmbeddedContent
        groupedTermsHiddenIds?: {
          termId: number
        }[]
        recurringPaymentsPromoText?: {
          label?: Label
          icon?: EmbeddedAssetSquidexMetadata[]
          text: string
          dateDisplayFrom: string
          dateDisplayTo?: string
        }[]
        basketUpsellPlan?: CloudBluePlan[]
      }
    }
  }
}

export function useCheckoutConfigurationQuery(): Query["GraphCmsSquidex"]["findCheckoutConfigurationSingleton"]["flatData"] {
  const {
    GraphCmsSquidex: { findCheckoutConfigurationSingleton },
  } = useStaticQuery<Query>(graphql`
    {
      GraphCmsSquidex {
        findCheckoutConfigurationSingleton {
          flatData {
            hasStepsInHeader
            termsText {
              text
              contents {
                ... on GraphCmsSquidex_StaticPrice {
                  ...StaticPrice
                }
                ... on GraphCmsSquidex_MarketplaceSaleConfiguration {
                  ...SaleConfigurations
                }
                ... on GraphCmsSquidex_CloudblueDomain {
                  ...CloudBlueDomain
                }
                ... on GraphCmsSquidex_PriceTypeContextText {
                  ...PriceTypeContextText
                }
                ... on GraphCmsSquidex_Tooltip {
                  ...Tooltip
                }
              }
            }
            expandedTerms {
              id
            }
            tabsTermId
            hasGroupedTerms
            groupedTermsText {
              text
              contents {
                ... on GraphCmsSquidex_ModalTermsLink {
                  ...ModalTermsLink
                }
                ... on GraphCmsSquidex_TermLink {
                  ...TermLink
                }
              }
            }
            groupedTermsHiddenIds {
              termId
            }
            recurringPaymentsPromoText {
              label {
                ...Label
              }
              icon {
                ...Image
              }
              text
              dateDisplayFrom
              dateDisplayTo
            }
            basketUpsellPlan {
              ...CloudBluePlan
            }
          }
        }
      }
    }
  `)

  return findCheckoutConfigurationSingleton.flatData
}
